<template>
  <div class="dvBgiBox">
    <p style="font-size: 22px;font-weight: 600;text-align: center;">{{ $t('center.title') }}</p>

    <div style="width: 100%;height: 100%;">
      <div style="display: flex;align-items: center;justify-content: center;margin-top: 10px;">
        <div style="display: flex;align-items: center;margin-right: 10px;">
          <div style="width: 10px;height: 10px;background-color: #2582fb;margin-right: 5px;"></div>
          <span>{{ $t('common.grid') }}</span>
        </div>

        <div style="display: flex;align-items: center;margin-right: 10px;">
          <div style="width: 10px;height: 10px;background-color: #35d9fe;margin-right: 5px;"></div>
          <span>{{ $t('common.storage') }}</span>
        </div>

        <div style="display: flex;align-items: center;margin-right: 10px;">
          <div style="width: 10px;height: 10px;background-color: #43fed4;margin-right: 5px;"></div>
          <span>{{ $t('common.pv') }}</span>
        </div>
      </div>
      <Echart ref="bottomLeftChart" :options="chartData" id="bottomLeftChart" height="85%" width="95%"></Echart>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
  data() {
    return {
      chartData: {}
    };
  },
  props: {
    photovoltaicType: {
      default: 1
    },
    cdata: {
      default: () => ({})
    },
  },
  components: {
    Echart
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale: {
      handler() {
        this.updateChartOptions();
      },
      immediate: true
    },
    cdata: {
      handler() {
        this.updateChartOptions();
      },
      deep: true
    }
  },
  mounted() {
    this.updateChartOptions();
  },
  methods: {
    updateChartOptions() {
      if (!this.cdata || !this.cdata.category) return;

      const isEn = this.$i18n.locale === 'en';
      
      const series = [
        {
          name: this.$t('common.grid'),
          type: "bar",
          smooth: true,
          showAllSymbol: true,
          symbol: "emptyCircle",
          symbolSize: 8,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: "#2582fb"
            }
          },
          data: this.cdata.lineData
        },
        {
          name: this.$t('common.storage'),
          type: "bar",
          smooth: true,
          showAllSymbol: true,
          symbol: "emptyCircle",
          symbolSize: 8,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: "#34d4fe"
            }
          },
          data: this.cdata.barData
        }
      ];

      // if (this.photovoltaicType != 1) {
        series.push({
          name: this.$t('common.pv'),
          type: "bar",
          smooth: true,
          showAllSymbol: true,
          symbol: "emptyCircle",
          symbolSize: 8,
          yAxisIndex: 1,
          itemStyle: {
            normal: {
              color: "#44fed9"
            }
          },
          data: this.cdata.photovoltaic
        });
      // }

      this.chartData = {
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(0,0,0,0.8)",
          textStyle: {
            fontSize: 22
          },
          axisPointer: {
            type: "shadow",
            label: {
              show: true,
              backgroundColor: "#7B7DDC"
            }
          }
        },
        grid: {
          x: "8%",
          width: "88%",
          y: "4%"
        },
        xAxis: {
          data: isEn ? this.cdata.categoryEn : this.cdata.category,
          axisLine: {
            lineStyle: {
              color: "#B4B4B4"
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#B4B4B4"
              }
            },
            axisLabel: {
              formatter: "{value} "
            }
          },
          {
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#B4B4B4"
              }
            },
            axisLabel: {
              formatter: "{value} kw"
            }
          }
        ],
        series: series
      };
    }
  }

}
</script>

<style scoped>
.dvBgiBox {
  width: 100%;
  height: 290px;
  background-image: url("../../assets/dvBgiBoxCenter.png");
  background-size: 100% 100%;
  padding: 10px;
}
</style>